// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-title[data-v-965b2230] {\n  font-size: 32px;\n  padding: 0;\n  line-height: 40px;\n}\n@media screen and (max-width: 550px) {\n.navParent[data-v-965b2230]{\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n}\n@media screen and (max-width: 425px) {\n}\n", ""]);
// Exports
module.exports = exports;
